/** @jsxImportSource theme-ui @jsxRuntime classic */
import { graphql } from 'gatsby';
import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';

import { Layout } from '../layouts';
import ErrorHeroBlock from '../blocks/ErrorHeroBlock';
import ErrorCrossLinkBlock from '../blocks/ErrorCrossLinkBlock';
import { safeDataLayerPush } from '../components/BuyTickets/utils';

import type { PageConfig } from '../PageConfig';

export const pageConfig: PageConfig = {
  theme: 'Rock Center',
  logo: 'Rockefeller Center',
  pageName: 'Rockefeller Center',
  cta: {
    to: '/buy-tickets/',
    label: 'Buy Tickets',
  },
};

export const query = graphql`
  query ErrorMeta {
    meta: dataJson(jsonId: { eq: "404" }) {
      meta {
        title
        description
      }
    }
  }
`;

export default function ErrorPage(): React.JSX.Element {
  const location = useLocation();
  useEffect(() => {
    safeDataLayerPush({
      event: 'Page Load Error',
      Step: '404',
      Referrer: document.referrer || null,
      PageName: location.pathname,
      UTC: new Date().toUTCString(),
      Error: 'Page Load Error',
      FromStep: document.referrer || null,
    });
  }, [location.pathname]);

  return (
    <Layout>
      <ErrorHeroBlock id="error-hero" />
      <ErrorCrossLinkBlock id="error-crosslink" theme="Rock Center Cream" />
    </Layout>
  );
}
